import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import {CodeListStatus} from '@gtpl/shared-models/planning';
export class CodeListDTO {
  @ApiProperty()
  @IsNotEmpty({message:"code list Id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  codeListId: number;

  @ApiProperty()
  @IsNotEmpty({message:"Unit id should not be empty"})
  @IsNumber()
  @IsOptional()
  unitId: number;
 
  @ApiProperty()
  @IsNotEmpty({message:"Traceability code should not be empty"})
  @IsNumber()
  @IsOptional()
  traceabilityCode: string;
  @ApiProperty()
  @IsNotEmpty({message:"Hrs per shift should not be empty"})
  @IsEnum(CodeListStatus)
  @IsOptional()
  CodeListStatus: CodeListStatus;
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

